import React from 'react';
import PhoneInput2 from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

const PhoneInput = ({ value, onChange, disabled }) => {
  const handleChange = (value, country) => {
    onChange({
      country_code: country.dialCode,
      phone_number: value.slice(country.dialCode.length)
    });
  };

  return (
    <PhoneInput2
      country={'il'}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      inputStyle={{ width: '100%' }}
      enableSearch={true}
    />
  );
};

export default PhoneInput;